import {UseFormReturn} from 'react-hook-form';

import {VehicleSelectionFormBinding} from '../../../types/VehicleSelectionFormBinding';
import {CampaignFormValues} from '../schemas/campaignFormSchema';

export const getCampaignVehicleSelectionBinding = (
  formApi: UseFormReturn<CampaignFormValues>
): VehicleSelectionFormBinding<CampaignFormValues> => ({
  getListFieldName: (field) => `filter.${field}`,
  getNumberFieldName: (field) => `filter.${field}`,
  getTextFieldName: (field) => `filter.${field}`,
  setListFieldValue: (field, value, options) => formApi.setValue(`filter.${field}`, value, options),
  setTextFieldValue: (field, value, options) => formApi.setValue(`filter.${field}`, value, options),
});
